import React, { Component } from 'react';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import { config } from "../../Config";
import Utility from '../../Utility';
import { List } from 'semantic-ui-react'
import './Gmap.css';
//import useResponsive from "../../hooks/useResponsive";

const style = {
  width: '100%',
  height: '100%'
}

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '100%'
}


export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  };

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  render() {

    //console.log(useResponsive);

    return (
      <div /*style={{ height: '50vh', width: '100%' }}*/ className="mapEtab">

        <Map
          style={style}
          containerStyle={containerStyle}
          google={this.props.google}
          initialCenter={{
            lat: this.props.lat,
            lng: this.props.lng
          }}
          zoom={10}
          onClick={this.onMapClicked}
          
          mapTypeControl = {false}
          streetViewControl = {false}
        >
          <Marker
            name={this.props.establishment.name}
            position={{
              lat: this.props.lat,
              lng: this.props.lng
            }}
            onClick={this.onMarkerClick}
          />

          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}>
            <div id="divInfoWindowMarker">
              <h4>{this.state.selectedPlace.name}</h4>
              <div>
                <div>
                  {/* <img className="ui medium image" src="https://motorsport.nextgen-auto.com/IMG/xarton146842.jpg,q1583721379.pagespeed.ic.o4UUpL9Zb7.webp"  /> */}
                  <img className="ui medium image" src={Utility.imageExists(this.props.establishment.logo, 'logo')} />
                </div>
                <List verticalAlign="middle">
                  <List.Item>
                    <List.Icon name="marker" />
                    <List.Content>
                      <List verticalAlign="middle" style={{paddingTop:0}}>
                        <List.Item>{this.props.establishment.firstAddress}</List.Item>
                        {(this.props.establishment.secondaryAddres !== '') ? <List.Item>{this.props.establishment.secondaryAddres}</List.Item> : null}
                        <List.Item>{`${this.props.establishment.zipCode}, ${this.props.establishment.city}`}</List.Item>
                      </List>
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon name="phone" />
                    <List.Content>{this.props.establishment.telephone}</List.Content>
                  </List.Item>
                  {(this.props.establishment.mobile !== '') ? 
                    <List.Item>
                      <List.Icon name="mobile" />
                      <List.Content>{this.props.establishment.mobile}</List.Content>
                    </List.Item>
                    : null}
                  <List.Item>
                    <List.Icon name="mail" />
                    <List.Content>
                      <a href={`mailto:${this.props.establishment.mail}`}>{this.props.establishment.mail}</a>
                    </List.Content>
                  </List.Item>
                </List>
              </div>
            </div>
          </InfoWindow>
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (config.Gmap.KEY),
})(MapContainer)